// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { getProductSelector } from "@insite/client-framework/Store/Components/ProductSelector/ProductSelectorSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Modals from "@insite/content-library/Components/Modals";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import useAreProductsLoading from "@store/Framework/Common/Hooks/useAreProductsLoading";
import ProductSelector, { ProductSelectorStyles } from "@store/Overrides/Components/ProductSelector";
import Search from "@toolkit/Library/Components/Icons/Search";
import React from "react";
import { css } from "styled-components";

const extendedStyles: ProductSelectorStyles = {
    searchDynamicDropdown: {
        iconProps: {
            src: Search,
        },
    },
    qtyGridItem: {
        css: css`
            display: none;
        `,
    },
    buttonGridItem: {
        css: css`
            display: none;
        `,
    },
    unitOfMeasureGridItem: {
        css: css`
            display: none;
        `,
    },
    container: {
        css: css`
            position: relative;
            z-index: 51;
        `,
    },
    searchGridItem: {
        css: css`
            width: 100% !important;
            max-width: 100% !important;
            flex-basis: 100% !important;
        `,
    },
};

const BulkListProductSelector: React.FC = () => {
    const areProductsLoading = useAreProductsLoading();

    return (
        <LoadingOverlay loading={areProductsLoading}>
            <Modals />
            <ProductSelector
                extendedStyles={extendedStyles}
                customLabel={translate("Product")}
                customPlaceholder={translate("Search for a product")}
                skipInventoryValidation
                onSelectProduct={() => {}}
            />
        </LoadingOverlay>
    );
};

const widgetModule: WidgetModule = {
    component: BulkListProductSelector,
    definition: {
        group: "Common",
        icon: "File",
    },
};

export default widgetModule;
